// src/pages/Contacts.js — Individuals: every person, every role.
import PeopleTable from '../components/people/PeopleTable'

export default function Contacts() {
  return <PeopleTable view="individuals" profileBase="/individuals" />
}
